import { useEffect, useState } from 'react';
import { cachedMyCompanies, refreshMyCompanies, subscribeMyCompanies } from './myCompaniesCache';

/**
 * The signed-in person's companies and pending invites, or null while unknown
 * (or when the backend has no answer — which every screen reads as "one
 * company, nothing to show").
 */
export default function useMyCompanies() {
  const [myCompanies, setMyCompanies] = useState(cachedMyCompanies);

  useEffect(() => {
    const unsubscribe = subscribeMyCompanies(setMyCompanies);
    let token = null;
    try {
      token = sessionStorage.getItem('token');
    } catch (e) {
      token = null;
    }
    if (!cachedMyCompanies() && token) refreshMyCompanies().catch(() => {});
    return unsubscribe;
  }, []);

  return { myCompanies, refresh: () => refreshMyCompanies() };
}
